(() => {
    "use strict";

    angular.module("app").controller("ConfirmStopFvmScreeningController", ConfirmStopFvmScreeningController);
    ConfirmStopFvmScreeningController.$inject = ["$scope", "notificationService", "webApiServices", "loadingIndicatorService", "ScreeningFunctions"];
    function ConfirmStopFvmScreeningController($scope, notificationService, webApiServices, loadingIndicatorService, ScreeningFunctions) {
        $scope.PageNumber = 1;
        $scope.sortType = "RequestDate"; // set the default sort type
        $scope.sortReverse = true; // set the default sort order
        $scope.selectAll = false;
        $scope.OpenScreening = openScreening;
        $scope.setPage = _setPage;
        $scope.ToggleAll = toggleAll;
        $scope.AreItemsSelected = areItemsSelected;
        $scope.ConfirmStopScreening = confirmStopScreening;
        $scope.ConfirmSelectedStopScreenings = confirmSelectedStopScreenings;
        $scope.CallStopScreeningsApi = callStopScreeningsApi;

        function openScreening(screening) {
            $scope.OpenedScreening = screening;
            $scope.OpenedScreeningStatus = screening.Status;
            ScreeningFunctions.OpenScreening(screening);
        };

        function _setPage(page) {
            $scope.PageNumber = page.toString();
            search();
        };

        function toggleAll() {
            if (!$scope?.Requests?.DtoList)
                return;
            $scope.selectAll = !$scope.selectAll;

            for (const element of $scope.Requests.DtoList) {
                element.isSelected = $scope.selectAll;
            }
        };

        function areItemsSelected() {
            if (!$scope?.Requests?.DtoList) return false;
            return $scope.Requests.DtoList.filter((i) => i.isSelected).length > 0;
        };

        function confirmStopScreening(screening) {
            if (!screening) return;
            callStopScreeningsApi([screening.PublicId]);
        };

        function confirmSelectedStopScreenings() {
            const selectedItems = $scope.Requests.DtoList.filter((i) => i.isSelected).map((i) => i.PublicId);
            if (!selectedItems) return;
            callStopScreeningsApi(selectedItems);
        };

        function callStopScreeningsApi(idStrings) {
            loadingIndicatorService.SetLoadingState(true);

            webApiServices.StopScreenings(
                { idStrings: idStrings },
                () => search(),
                null,
                () => loadingIndicatorService.SetLoadingState(false));
        };

        function search() {
            loadingIndicatorService.SetLoadingState(true);
            webApiServices.GetFvmScreeningsToStop(
                { Filter: { PageNumber: $scope.PageNumber } },
                (result) => {
                    if (CheckResultReceived(result)) $scope.Requests = result.data;
                },
                (err) => DoShowError(notificationService, err),
                () => loadingIndicatorService.SetLoadingState(false));
        }
        search();
    }
})();